import styled from 'styled-components';
import { default as MuiCard } from '@material-ui/core/Card/Card';
import NearMe from '@material-ui/icons/NearMe';
import PhoneIcon from '@material-ui/icons/Phone';

export const StyledCard = styled(MuiCard)`
  border-radius: 8px;
  background-color: #ffffff;
  border: 1px solid #e6e6e6;
  box-shadow: 0px 2px 24px rgba(0, 0, 0, 0.1);
  padding: 15px 15px 12px;
  width: 100%;
`;

export const TextContainer = styled.div`
  min-width: 100px;
  flex-grow: 1;
`;

export const SubTitle = styled.div`
  color: #666666;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Title = styled.h2`
  color: #000000;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  margin: 0 0 9px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const LockIconContainer = styled.div`
  color: #999999;
  position: absolute;
  top: 8px;
  right: 32px;
`;

export const StyledNearMe = styled(NearMe)`
  fill: #426389;
`;

export const StyledPhoneIcon = styled(PhoneIcon)`
  fill: #00bb7e;
`;

export const StyledData = styled.div`
  display: flex;

  > div {
    flex-basis: 50%;
  }
`;

export const StyledDescription = styled.div`
  border-radius: 4px;
  background-color: #f2f2f2;
  margin-top: 8px;
  padding: 12px 22px 12px 12px;
  display: block;
  box-sizing: border-box;
  position: relative;

  a {
    color: #000;
    display: block;
  }

  > svg {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    fill: #ccc;
    font-size: 20px;
  }
`;

export const CollapsibleWrapper = styled.div`
  width: 100%;

  > div {
    margin-top: 5px;
  }
`;

export const CollapseButton = styled.div`
  padding-top: 8px;
  width: 100%;
  cursor: pointer;
  text-align: center;
`;

export const ClassificationCodeContainer = styled.div`
  position: absolute;
  right: 8px;
`;
